import React from "react";

import Sidebar from "../../../components/AdminComponents/SideNav";

import { Table, Button, Input, Modal, Form, Spin } from "antd";
import { useState, useRef, useEffect } from "react";
import { DeleteTwoTone, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import "./settingStyles.css";
import { message } from "antd";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import EditableImage from "../../../components/icons/EditIcon";
import Axios from "../../../api/Axios";
import { Pagination } from "antd";

import EditNaics from "../../../components/AdminComponents/Modals/EditNaics";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
const { Item } = Form;

const SettingsNaics = () => {
  const handleRowClick = (record) => {
    //console.log(record);
    setModalData(record);
    setVisible(true);
  };

  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState(false);

  const onFinish = (values) => {
    //console.log("Form values:", values);
  };

  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const formRef = useRef();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus1(userInfo, 2, 0);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/naicslist/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };

  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Naics details have been ${props}.`,
      duration: 5,
    });
    LoadUser();
    if (props === "created") {
      handleReset();
    }
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Naics details have not been ${props}.`,
      duration: 5,
    });
  };

  const columns = [
    {
      title: capitalizeWords("code"),
      dataIndex: "code",
      key: "code",
    },
    {
      title: capitalizeWords("TITLE"),
      dataIndex: "title",
      key: "title",
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("actions"),
            key: "actions",
            align: "center",
            render: (text, record) => {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
                  <EditableImage
                    handleRowClick={handleRowClick}
                    recordId={record}
                    key={`edit-${record.code}`}
                    disabled={false}
                  />
                  <DeleteTwoTone
                    key={`delete-${record.code}`}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
    formRef.current.resetFields();
  };
  const handleCancel2 = () => {
    setVisible(false);
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleReset = () => {
    formRef.current.resetFields();
  };

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };

  return (
    <div>
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <CommonTopDetails
          title="NAICS"
          titleSuffix={`${itemsLength || 0} codes(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          showAddButton={updateAuth}
          // showModal={showModal}
          addButtonProps={{
            modalType: "PopUP",
            modalProps: showModal,
          }}
        />
        {/* <div className="using-class">
          <div className="search-container">
            <div className="heading-text">
              NAICS |{" "}
              <span className="gold-text-span">{itemsLength} codes(s)</span>
            </div>
          </div>

          <Input.Search
            className="search-input"
            placeholder="Search by..."
            enterButton
            value={search}
            onChange={handleSearchChange}
            key="search-input"
          />
          {updateAuth && (
            <Button
              type="primary"
              htmlType="button"
              className="setting-add"
              onClick={showModal}
            >
              + Add New
            </Button>
          )}
        </div> */}
        <Spin spinning={loading}>
          <Table
            size="small"
            dataSource={data}
            columns={columns}
            bordered
            rowKey="id"
            scroll={{
              x: 1000,
              y: `${remainingViewportHeight(24)}px`,
            }}
            className="table-container"
            style={{ margin: "1rem" }}
            pagination={false}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onPageChange}
              pageSizeOptions={["10", "15", "30", "50", "100"]}
              showQuickJumper
              current={currentPage}
              defaultPageSize={pageSize}
              total={itemsLength}
            />
          </div>
        </Spin>
        <Modal
          title={<p className="modal-heading">ADD NEW NAICS CODE</p>}
          centered
          // open={modalOpen}
          // onOk={() => setModalOpen(false)}
          // onCancel={() => setModalOpen(false)}
          onOk={handleOk}
          onCancel={handleCancel}
          open={open}
          footer={[]}
        >
          <Form onFinish={onFinish} style={{ marginTop: "3rem" }} ref={formRef}>
            <Item
              label={<p className="modal-text">NAICS Code</p>}
              name="naicsCode"
              rules={[
                { required: true, message: "Please input a NAICS code" },
                {
                  pattern: /^[0-9]{6}$/,
                  message: "NAICS code should be a 6-digit number",
                },
              ]}
            >
              <Input placeholder="Enter NAICS code" />
            </Item>
            <Item
              label={<p className="modal-text">NAICS Title</p>}
              name="title"
              rules={[
                { required: true, message: "Please input a title" },
                {
                  max: 100,
                  message: "Title should not exceed 100 characters",
                },
              ]}
            >
              <Input placeholder="Enter title" />
            </Item>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                height: "2rem",
              }}
            >
              <Form.Item style={{ marginRight: "1rem" }}>
                <Button key="back" onClick={handleCancel}>
                  <CloseOutlined />
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#f58029",
                    fontWeight: "600",
                  }}
                  className="save-update-btn"
                >
                  Save
                  <SaveOutlined />
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
        <EditNaics
          key={modalData.code}
          visible={visible}
          modalData={modalData}
          onCancel={handleCancel2}
          CreateSuccessfull={CreateSuccessfull}
          CreateFailed={CreateFailed}
        />
      </Sidebar>
    </div>
  );
};

export default SettingsNaics;
